export const getFormDetails = (data = {}, properties, defaultValue = null) => properties.reduce((details, property) => {
    if (typeof property === 'object') {
      const { name, defaultValue: ownDefaultValue = defaultValue } = property;
      details[name] = data[name] ?? ownDefaultValue;
    } else {
      details[property] = data[property] ?? defaultValue;
    }
    return details;
  }, {});

export const getFormSubmitDetails = (data) => {
  const details = { ...data };

  Object.keys(details).forEach((key) => {
    if (!details[key] && details[key] !== 0 && details[key] !== false) details[key] = null;
  });

  return details;
};

export const getPropertyWithString = ({ data, property }) =>
  property?.split('.').reduce((obj, key) => (obj ? obj[key] : null), data);

export const formatAmount = (amount) => typeof amount === 'number' && `${amount.toFixed(2)} $`;

// Permission
export const hasPermission = (user, permissionName) =>
  !!user?.permissions?.find(({ permission }) => permission === permissionName);

export const findConfigItem = (config, id) =>
  id.split('.').reduce((obj, key) => (obj.config || obj).find((item) => item.id === key), config);

export const upperCaseFirstLetter = (string) =>
  string && string[0].toUpperCase() + string.slice(1).toLowerCase();

export const deepClone = (arr) => arr.map((item) => ({ ...item }));

export const scrollToElement = (scrollRef) =>
  requestAnimationFrame(() =>
    scrollRef.current?.scrollIntoView({ block: 'start', behavior: 'smooth' })
  );

export const checkNullish = (value) => value === null || value === undefined;
